module.exports = __webpack_public_path__ + "img/d03d0df6c1e6060371bd6eb99c200345.png";